﻿{
  "version": 1,
  "gameId": "soccer-flick",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "soccer-flick.rules.navigationLabel",
    "kickerKey": "soccer-flick.rules.kicker",
    "titleKey": "soccer-flick.rules.title",
    "summaryKey": "soccer-flick.rules.summary",
    "sections": [
      { "id": "teams", "key": "soccer-flick.rules.teams" },
      { "id": "aim", "key": "soccer-flick.rules.aim" },
      { "id": "motion", "key": "soccer-flick.rules.motion" },
      { "id": "turns", "key": "soccer-flick.rules.turns" },
      { "id": "goals", "key": "soccer-flick.rules.goals" },
      { "id": "victory", "key": "soccer-flick.rules.victory" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic-green", "nameKey": "soccer.shop.board.classicGreen", "price": 0, "image": "/assets/boards/soccer-flick/board.webp" },
      { "id": "woodgrain", "nameKey": "soccer.shop.board.woodgrain", "price": 180, "image": "/assets/boards/soccer-flick/woodgrain.webp" },
      { "id": "steel-grid", "nameKey": "soccer.shop.board.steelGrid", "price": 300, "image": "/assets/boards/soccer-flick/steel-grid.webp" },
      { "id": "clay-court", "nameKey": "soccer.shop.board.clayCourt", "price": 120, "image": "/assets/boards/soccer-flick/clay-court.webp" },
      { "id": "sand-arena", "nameKey": "soccer.shop.board.sandArena", "price": 220, "image": "/assets/boards/soccer-flick/sand-arena.webp" },
      { "id": "rust-pit", "nameKey": "soccer.shop.board.rustPit", "price": 420, "image": "/assets/boards/soccer-flick/rust-pit.webp" },
      { "id": "neon-grid", "nameKey": "soccer.shop.board.neonGrid", "price": 600, "image": "/assets/boards/soccer-flick/neon-grid.webp" },
      { "id": "street-court", "nameKey": "soccer.shop.board.streetCourt", "price": 520, "image": "/assets/boards/soccer-flick/street-court.webp" }
    ],
    "ballThemes": [
      { "id": "classic-ball", "nameKey": "soccer.shop.ball.classic", "price": 0, "image": "/assets/boards/soccer-flick/ball.webp" },
      { "id": "leather-match", "nameKey": "soccer.shop.ball.leatherMatch", "price": 120, "image": "/assets/boards/soccer-flick/ball-leather.webp" },
      { "id": "world-cup", "nameKey": "soccer.shop.ball.worldCup", "price": 260, "image": "/assets/boards/soccer-flick/ball-world-cup.webp" },
      { "id": "atlas-voyage", "nameKey": "soccer.shop.ball.atlasVoyage", "price": 340, "image": "/assets/boards/soccer-flick/ball-atlas.webp" },
      { "id": "jungle-bloom", "nameKey": "soccer.shop.ball.jungleBloom", "price": 380, "image": "/assets/boards/soccer-flick/ball-jungle.webp" }
    ]
  }
}
